"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var preferredConsultantStyles = makeStyles_1.default(function (_a) {
    var palette = _a.palette, typography = _a.typography;
    return ({
        wrapper: {
            borderTop: "1px solid " + palette.primaryDisabled.main,
            padding: '20px 0',
        },
        title: {
            fontFamily: typography.fontFamily2,
        },
        element: {
            fontFamily: typography.fontFamily,
            padding: '5px 0',
        },
        preferredConsultant: {},
    });
}, { name: 'GqlSummary_PreferredConsultant' });
exports.default = preferredConsultantStyles;
